import expensePayments from './expense-payments';
import expenses from './expenses';
import purchaseOrders from './purchase-orders';
import purchasesCreditMemoPayments from './purchases-credit-memo-payments';
import purchasesCreditMemos from './purchases-credit-memos';
import receivedInvoices from './received-invoices';
import recurringExpenses from './recurring-expenses';

let messages = Object.assign({}, expensePayments, expenses, purchaseOrders, purchasesCreditMemoPayments, purchasesCreditMemos, receivedInvoices, recurringExpenses);

export default messages;
